// スコアの色分け・表示ユーティリティ
import type { ItemStatus } from '@shared/types';

/** スコア(0..100) → 信号色。80+緑 / 60-79黄 / 60未満赤 */
export function scoreColor(score: number): string {
  if (score >= 80) return '#1a9850'; // green
  if (score >= 60) return '#e0a800'; // amber
  return '#d7301f'; // red
}

export function scoreLabel(score: number): string {
  if (score >= 80) return '良好';
  if (score >= 60) return '要改善';
  return '課題あり';
}

/** 項目ステータスの表示メタ */
export const STATUS_META: Record<
  ItemStatus,
  { label: string; color: string; order: number }
> = {
  fail: { label: 'NG', color: '#d7301f', order: 0 },
  warn: { label: '注意', color: '#e0a800', order: 1 },
  pass: { label: 'OK', color: '#1a9850', order: 2 },
  na: { label: '対象外', color: '#9aa0a6', order: 3 },
};

/** 課題リストの並び順: fail > warn > pass > na、同順位は critical 優先 */
export function itemSortKey(status: ItemStatus, critical?: boolean): number {
  return STATUS_META[status].order * 10 + (critical ? 0 : 1);
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}
